import { combineReducers } from "redux";
import { reducer as formReducer } from "redux-form";

import entity, { initialState as initialEntity } from "data/entity";

import assets, { initialState as initialAssets } from "data/assets";

import sections, { initialState as initialSections } from "data/sections";

import user, { initialState as initialUser } from "data/user";

import campaignsReducer from "data/campaigns";
import campaignSearchReducer from "data/campaign-search";
import paginationReducer from "data/pagination";

import givingReducer from "data/giving-form";

import votingReducer from "data/voting-form";

import spreedly, { initialState as spreedlyInitial } from "data/spreedly";

export const initialState = {
  entity: initialEntity,
  assets: initialAssets,
  sections: initialSections,
  user: initialUser,
  spreedly: spreedlyInitial,
};

export default (asyncReducers) => {
  return combineReducers({
    entity,
    assets,
    sections,
    user,
    form: formReducer,
    campaigns: campaignsReducer,
    campaignSearch: campaignSearchReducer,
    pagination: paginationReducer(),
    giving_form: givingReducer,
    voting_form: votingReducer,
    spreedly,
    ...asyncReducers,
  });
};
